import { useMutation } from "@tanstack/react-query";
import { postPOD } from "src/api/pod";
const useCreatePOD = ()=>{
    return useMutation({
        mutationFn: (params)=>postPOD(params)
    });
};
export default useCreatePOD;
